var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-x":"","left":"","transition":"slide-x-reverse-transition","close-delay":300,"open-delay":200},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.menuIcon))])],1)]}}])},[_c('v-list',{attrs:{"nav":"","dense":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }